import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteMechanic } from '../../../../actions/mechanical-maintenance/Mechanic';

const MechanicDeleteButton = ({
  dispatchDeleteMechanic,
  mechanicId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteMechanic({ mechanicId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

MechanicDeleteButton.propTypes = {
  dispatchDeleteMechanic: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  mechanicId: PropTypes.number.isRequired,
};

MechanicDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteMechanic: deleteMechanic,
};

export default connect(null, mapDispatchToProps)(MechanicDeleteButton);
